import { P } from 'ia-react-core';
import styled from 'styled-components';

export const StyledLine = styled(P)`
  width:53%;
  margin-bottom: 0;
  line-height: 1.49;
`;
